const styles = theme => ({
  button: {
    marginRight: theme.spacing(1),
  },
  halfInput: {
    width: '50%',
  },
  dialog: {
    minWidth: '310px',
  },
  leftInput: {
    marginRight: theme.spacing(1),
  },
})

export default styles
